import { ArrowRightIcon } from '@langchain/untitled-ui-icons';

import { Button } from '@/design-system';
import { ExampleSchemaWithRunsAndOptionalFields } from '@/types/schema';

export const DatasetExampleButton = ({
  example,
  isTextTruncated,
  onClick,
}: {
  example: ExampleSchemaWithRunsAndOptionalFields;
  isTextTruncated: boolean;
  onClick: () => void;
}) => {
  return (
    <Button
      onClick={onClick}
      color="secondary"
      variant="outlined"
      size="sm"
      rightDecorator={ArrowRightIcon}
    >
      {!isTextTruncated && 'Example '}
      {example.name?.split(' @')[0]}
    </Button>
  );
};
